import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'convertTRange',
  standalone: true
})
export class ConvertToRangePipe implements PipeTransform {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(number: number): any {
    return _.range(1, number+1);
  }

}
